import React from 'react';
export const HeadlineTitle = ({ children, ...props }) => <h2 {...props}>{children}</h2>;
